<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 19:09:22
-->
<template>
  <section>
    <div class="role">
      <!-- <i class="fa-line"></i> -->
      <div class="roleRight" style="border-left: 0;padding-bottom: 30px">
        <div class="roleRight_Top">
          <el-input
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              v-if="searchShow"
              @keyup.enter.native="QueryOrganizationManagement"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="QueryOrganizationManagement"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data car_post">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              row-key="advertiserDeptId"
              default-expand-all
              style="width: 100%; max-width: 1400px"
              :tree-props="{ children: 'children' }"
          >
            <el-table-column prop="name" label="名称" style="text-align: left !important;"></el-table-column>
            <el-table-column prop="seq" width="100px" label="排序"></el-table-column>
            <el-table-column prop="status" width="100px" label="状态">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="240">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button>
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑投放组"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="460px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item
              class="item"
              label="上级："
              style="position: relative"
          >
            <span class="clear_icon_items">*</span>
            <el-select
                ref="selectReport"
                v-model="dictDataSelect"
                clearable
                placeholder="选择上级"
            >
              <el-option
                  :key="params.advertiserDeptId"
                  :label="params.name"
                  :value="params.advertiserDeptId"
                  style="height: auto"
              >
                <el-tree
                    :data="tableData"
                    node-key="advertiserDeptId"
                    ref="tree"
                    default-expand-all
                    :props="defaultProps"
                    :render-after-expand="true"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- add group -->
          <el-form-item
              class="item"
              label="名称："
              prop="name"
          >
            <el-input
                clearable
                placeholder="请填写组织名称(10字以内) "
                v-model="params.name"
                maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="排序："
          >
            <el-input
                clearable
                placeholder="请填写排序"
                v-model="params.seq"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="说明："
          >
            <el-input type="textarea" :rows="4" placeholder="最长为200个字符" v-model="params.descr"
                      maxlength="200"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>

  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";

export default {
  data() {
    return {
      PAGE_SIZE,
      loading: false,
      //上一级展示的词语
      dictDataSelect: "",

      defaultProps: {
        children: "children",
        label: "name",
      },

      search: {},

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "change"}],
        orgId: [
          {required: true, message: "请选择上级", trigger: "change"},
        ],
      }, //表单验证提示

      tableData: [], //二级--组织列表


      childArr: [], //点击选择的orgId

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  created() {
    this.getRoleListTree();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.dictDataSelect = ""; //上一级回显数据清除
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    //权限
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'launch:group:query') {
            this.searchShow = true
          }
          if (item.code == 'launch:group:add') {
            this.addShow = true
          }
          if (item.code == "launch:group:delete") {
            this.deleteShow = true
          }
          if (item.code == "launch:group:edit") {
            this.editShow = true
          }
          if (item.code == "launch:group:status") {
            this.statusShow = false
          }
        })
      }
    },

    QueryOrganizationManagement() {
      this.getRoleListTree()
    },
    /**
     *  获取列表数据
     */
    async getRoleListTree(node) {
      let http = "/advertiser/dept/list?tree=true&paging=false";
      this.loading = true;
      //组织列表
      const {data: resData} = await this.$get(http, {
        params: {...this.search},
      });
      this.loading = false;
      this.tableData = resData.data;
    },

    //switch状态改变 --接口 修改组织状态
    handleSwitch(e) {
      //interface
      this.$put(`/advertiser/dept/info/status/${e.advertiserDeptId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "change") {
        //修改  change
        this.params = {
          advertiserDeptId: row.advertiserDeptId,
          name: row.name,
          descr: row.descr,
          parentId: row.parentId,
          seq: row.seq,
        };
        // id:当前节点id
        if (row.nodeLevel != 1) {
          setTimeout(()=>{
            this.dictDataSelect = this.$refs.tree.getNode(
                row.advertiserDeptId
            ).parent.data.name;
          },500)
        }
      } else {
        //添加
        this.dictDataSelect = "";
        this.params = {};
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = {
          name: this.params.name,
          parentId: this.params.parentId,
          advertiserDeptId: this.params.advertiserDeptId,
          descr: this.params.descr,
          seq: parseInt(this.params.seq),
        };
        if (!valid) return;

        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            if (this.dictDataSelect == "") passData.parentId = 0;
            passData.orgId = "";
            const {data: resData} = await this.$post("/advertiser/dept/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改组织
              if (this.dictDataSelect == "") {
                passData.parentId = 0;
              }
              const {data: resData} = await this.$put("/advertiser/dept/info", passData, {
                headers: {
                  isLoading: true,
                },
              });
              if (resData.result != 200) return;
              this.getRoleListTree(); //重新获取数据

              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //菜单分配
            }
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(`/advertiser/dept/info/${row.advertiserDeptId}`, {
          headers: {
            isLoading: true,
          },
        });
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },

    // 选择组织组
    handleNodeClick: function (node) {
      //node是点击的父级别
      this.dictDataSelect = node.name;

      if (this.clickType == "change") {
        this.params.parentId = node.advertiserDeptId;
      } else {
        this.params.parentId = node.advertiserDeptId;
      }
      this.$refs.selectReport.blur();
    },

  },
};
</script>

<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -63px;
  top: 0;
}

.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    padding-right: 15px;
    width: auto;
    min-width: 180px;
    transition: all 0.3s linear;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  &Right {
    border-left: 1px solid #ccc;
    padding-left: 15px;
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.channel_items {
  display: flex;
  margin-bottom: 15px;

  .titles {
    width: 80px;
    text-align: right;
  }
}

.table_cou {
  height: auto;
  width: calc(100% - 80px);

  .tab_header_th {
    height: 30px;
    border: 1px solid rgba(231, 231, 231, 1);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-left: 1px solid rgba(231, 231, 231, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .qutuns {
      width: 100px;
    }

    .names {
      width: 80px;
    }

    .name_box_auto {
      width: 220px;
    }

    .code_box {
      width: 100px;
    }

    .post_inof {
      width: 80px;
    }

    .inde_auto {
      width: 50px;
    }

    .comtemts {
      width: 120px;
    }
  }

  .tab_body_content {
    .tab_content_td {
      display: flex;
      border: 1px solid rgba(231, 231, 231, 1);
      border-top: none;
      box-sizing: border-box;
      min-height: 30px;
      border-bottom: none;
    }

    .right_contents {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 80px);

      .right_items {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 30px;
        border-bottom: 1px solid rgba(231, 231, 231, 1);

        div {
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-left: 1px solid rgba(231, 231, 231, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .account_index {
          width: 50px;
        }
      }

      .account_box {
        width: 200px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
      }

      .contun_box_c {
        width: 100px;
        border-left: 1px solid rgba(231, 231, 231, 1);

        .box_icons {
          padding: 5px 10px;
          font-size: 12px;
          color: #ffffff;
          background-color: #3a8ee6;
          border-radius: 4px;
        }

        .active_none {
          background-color: rgba(0, 0, 0, 0.1);
          color: #606266;
        }
      }

      .account_name {
        width: 100px;
        padding: 0 10px;
      }

      .account_code {
        width: 100px;
      }

      .account_putWay {
        width: 80px;
      }

      .account_des {
        width: 100px;
      }
    }

    .left_contents {
      width: 80px;
      border-bottom: 1px solid rgba(231, 231, 231, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.items {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .left_name {
    width: 120px;
    text-align: right;

  }
}

.info_tab_tas {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.roleRight .car_post .el-table .el-table_1_column_1 {
  text-align: left !important;
}

.roleRight .car_post .el-table tbody tr td:nth-child(1) {
  text-align: left !important;
}

.roleRight .car_post .el-table .el-table_1_column_1 {
  text-align: left !important;

  .disabled_tab {
    .el-switch__core {
      background-color: #606266 !important;
      border-color: #606266 !important;
    }
  }
}

</style>